<template>
  <div class="bankDetail">
    <div class="bankDetail-top">
      <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
      <div>银行卡</div>
      <div></div>
    </div>

    <div class="bankDetail-list" v-for="item in bindCardDetail" :key="item.id">
      <div class="list">
        <div class="list-detail">
          <div class="list-bank-name">{{item.bankName}}</div>
          <div class="list-bank-num">{{item.bankNo}}</div>
        </div>
        <div class="list-img">
          <div class="list-bank-img">
            <img :src="aliyun+item.bankCode+imgType" alt="">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      bindCardDetail:[],
      aliyun:"https://bpo-dev.oss-cn-beijing.aliyuncs.com/client/bank_logo/",
      imgType:".png"
    }
  },
  mounted(){
    this.myWalletDedail()
  },
  methods:{
    goBack(){
      this.$router.go(-1)
    },
    myWalletDedail(){
      http.post(config.myWallet).then(({code,data})=>{
        // this.bankNo=data.bindCardDetail[0].bankNo;
        // this.bankName=data.bindCardDetail[0].bankName;
        // this.mobile=data.mobile;
        // this.totalAmount=data.totalAmount;
        // this.bankAccount=data.myAccount.bankAccount;
        this.bindCardDetail=data.bindCardDetail;
        this.bankImg=`https://bpo-dev.oss-cn-beijing.aliyuncs.com/client/bank_logo/${data.bindCardDetail[0].bankCode}.png`
      })
    },
  }
  
}
</script>
<style lang="less" scoped>
.bankDetail{
  padding:20px;
  .bankDetail-top{
    .jian{
      font-size: 35px;
      color: #333333;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    padding-bottom: 14px;
    border-bottom: 1px solid #F7F7F7;
    font-size: 32px;
  }
  .bankDetail-list{
    width: 100%;
    display: flex;
    height: 280px;
    justify-content: center;
    .list{
      display: flex;
      width: 90%;
      justify-content: space-between;
      align-items: center;
      background: url(../../../assets/img/yinhangka.png) no-repeat;
      background-size: contain;
      padding: 30px 50px;
      box-sizing: border-box;
      color: #ffffff;
      margin-top: 15px;
      .list-detail{
        text-align: left;
        .list-bank-name{
          font-size: 32px;
          margin-bottom: 15px;
        }
        .list-bank-num{
          font-size: 28px;
        }
      }
      .list-img{
        .list-bank-img{
          width: 80px;
          height: 80px;
          background: #ffffff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 80%;
            height: 80%;
          }
        }

      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/wallet/bankDetail/index.vue